/**
 * Enum representing different market periods.
 */
export enum MarketPeriod {
  PRE_MARKET = 'pre-market',
  REGULAR_MARKET = 'regular-market',
  AFTER_MARKET = 'after-market',

  /**
   * Market closed is only in affect when its a WEEKEND or a HOLIDAY, otherwise we use AFTER_MARKET
   */
  MARKET_CLOSED = 'market-closed',
}
